import { Spinner, SpinnerSize } from "@fluentui/react";
import React, { useContext } from "react";
import { ThemeContext } from "@fluentui/react-theme-provider";
import { RefundEstimationDates } from "../../../services/FundService";
import { SectionContainer, WarningContainer } from "../styles/RefundsStyles";
import '../styles/RefundTimeLine.css';

const WARNING_TEXT = "Las fechas de valor liquidativo y liquidación, así como los días fuera de mercado expuestos son una estimación informativa que NO tiene en cuenta los días no laborables del país de origen del fondo y no constituyen una garantía para ningún tipo de reclamación por dicha información expuesta. Asimismo, se recuerda al inversor que para poder calcular la estimación más exacta, deberá analizar la memoria de comercialización, el folleto y el resto de documentaciones pre-contractuales de los vehículos donde figuren las horas de corte y el periodo del cálculo liquidativo establecidas por las entidades comercializadoras y las gestoras de los mismos.";

type RefundProps =
{
    refundEstimationDates: RefundEstimationDates,
    isLoading?: boolean,
};

export const RefundTimeLine = (props: RefundProps) =>
{
    const theme = useContext(ThemeContext);
    const themeName = (theme as {name?: string; palette?: {name?: string}} | undefined)?.name ?? (theme as {palette?: {name?: string}} | undefined)?.palette?.name;
    const isDark = themeName === "dark";
    const showLoading = props.isLoading === true;

    const rowClass = isDark ? "principalRowContainerBlack" : "principalRowContainer";
    const progressId = isDark ? undefined : "progress";
    const textClass = isDark ? "circleTextWhite" : "circleTextBlack";
    const dateClass = isDark ? "circleDateWhite" : "circleDateBlack";
    const spinnerStyles = {root: { margin: "3em 1.5em 1.5em 23em !important" as const } };

    return(
        <div className={`ms-Grid-row ${rowClass}`}>
            {showLoading &&
            (
                <React.Fragment>
                    <Spinner size={SpinnerSize.large} className="button-spinner" styles={spinnerStyles} />
                    <SectionContainer className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12 ms-xxxl12">
                        <WarningContainer>
                            <div>
                                <img src="/icons/information.svg" alt="Información" />
                            </div>
                            <p style={isDark ? undefined : {cursor: "default"}}>{WARNING_TEXT}</p>
                        </WarningContainer>
                    </SectionContainer>
                </React.Fragment>
            )}
            {!showLoading &&
            (
                <React.Fragment>
                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12 ms-xxxl12">
                        <div className="bodyContainer">
                            <div className="container">
                                <div className="progress-container">
                                    <div className="progress" id={progressId} />
                                    <div className="circleVenta realized" />
                                    <div className="circleVenta realized">
                                        <p className={textClass}>Fecha de Valor Liquidativo Salida</p>
                                    </div>
                                    <div className="circleVenta realized">
                                        <p className={textClass}>Fecha Liquidación Salida</p>
                                    </div>
                                    <div className="circleVenta realized" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12 ms-xxxl12">
                        <div className="dateBody-container">
                            <div className="container">
                                <div className="date-container">
                                    <div className="circleEmptyLeft" style={{cursor: "default"}}>{new Date().toLocaleDateString()}</div>
                                    <p className={dateClass}>{props.refundEstimationDates.ventaValor}</p>
                                    <p className={dateClass}>{props.refundEstimationDates.ventaLiquidacion}</p>
                                    <div className="circleEmptyRight" style={{cursor: "default"}}>{props.refundEstimationDates.finalProceso}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <SectionContainer className="ms-Grid-col ms-sm12 ms-md12 ms-lg12 ms-xl12 ms-xxl12 ms-xxxl12">
                        <WarningContainer>
                            <div>
                                <img src="/icons/information.svg" alt="Información" />
                            </div>
                            <p style={isDark ? undefined : {cursor: "default"}}>{WARNING_TEXT}</p>
                        </WarningContainer>
                    </SectionContainer>
                </React.Fragment>
            )}
        </div>
    );
};